import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import { StubReport } from "../../../components/Reports/Employee/StubReport";

export interface IStubReportPage {}

export const StubReportPage: FC<IStubReportPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Stub Report"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<StubReport />}
		/>
	);
};
